import { render, staticRenderFns } from "./organization-signup-form.vue?vue&type=template&id=db6cdebc&"
import script from "./organization-signup-form.vue?vue&type=script&lang=js&"
export * from "./organization-signup-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports